import { useState } from 'react';
import { BoutonPrincipal, BoutonSecondaire, MessageErreur } from '../ui/Primitives';
import { PaveSignature } from '../ui/PaveSignature';

/**
 * Recueil d'une signature manuscrite (CDC §5.4).
 *
 * Partagé par le module de signature et l'écran des documents pédagogiques :
 * le geste est le même — on tend la tablette, la personne signe — et il ne doit
 * pas dépendre de l'écran depuis lequel on l'a déclenché.
 */
export function ZoneSignature({
  libelle,
  signataire,
  empreinteDocument,
  enCours,
  erreur,
  resultat,
  onAnnuler,
  onSigner,
}: {
  libelle: string;
  signataire: { nom: string; roleLibelle: string };
  empreinteDocument: string | null;
  enCours: boolean;
  erreur: string | null;
  resultat: { mention: string; scellee: boolean } | null;
  onAnnuler: () => void;
  onSigner: (trace: string) => void;
}): JSX.Element {
  const [trace, setTrace] = useState<string | null>(null);
  const [consentement, setConsentement] = useState(false);

  return (
    <div className="space-y-4 p-4 sm:p-6">
      <div>
        <div className="text-sm font-semibold text-codialis-navy">{libelle}</div>
        <div className="text-xs text-codialis-gray">
          Signataire : {signataire.nom} ({signataire.roleLibelle})
        </div>
        {empreinteDocument && (
          <div className="mt-1 break-all font-mono text-[10px] text-codialis-gray">
            Empreinte du document : {empreinteDocument.slice(0, 32)}…
          </div>
        )}
      </div>

      <PaveSignature onChanger={setTrace} desactive={enCours} />

      <label className="flex items-start gap-2 text-xs text-codialis-gray">
        <input
          type="checkbox"
          className="mt-0.5 rounded"
          checked={consentement}
          onChange={(evenement) => setConsentement(evenement.target.checked)}
        />
        J’accepte de signer ce document. Ma signature, son horodatage, l’empreinte du
        document et mon adresse IP sont conservés comme preuve.
      </label>

      {erreur && <MessageErreur message={erreur} />}
      {resultat && (
        <div className="rounded-xl bg-codialis-sand p-3 text-[11px] text-codialis-navy">
          {resultat.mention}
        </div>
      )}

      <div className="flex flex-wrap gap-2">
        <BoutonPrincipal
          onClick={() => trace && onSigner(trace)}
          disabled={!trace || !consentement || enCours}
        >
          {enCours ? 'Scellement…' : 'Valider la signature'}
        </BoutonPrincipal>
        <BoutonSecondaire onClick={onAnnuler} disabled={enCours}>
          Annuler
        </BoutonSecondaire>
      </div>
    </div>
  );
}
